import { Button, Card, CardHeader, Text } from "@fluentui/react-components";
import { Delete16Regular } from "@fluentui/react-icons";
import { isImage, resolveAsset } from "common/fileIcons";
import { IFilePreviewProps } from "./FilePreview.types";
import { designTokens } from "theme/customTheme";

export const FilePreview = (props: IFilePreviewProps) => {
  return (
    <>
      {props.files.length > 0 &&
        props.files.map((fileWithId) => {
          const isImageFile: boolean = isImage(fileWithId.file.name);
          return (
            <Card
              key={fileWithId.id}
              style={{ borderRadius: designTokens.borderRadius.xl }}
              size="small"
              role="listitem"
            >
              <CardHeader
                image={{
                  as: "img",
                  src: resolveAsset(fileWithId.file.name, fileWithId.file),
                  alt: fileWithId.file.name,
                  width: "40px",
                  height: "40px",
                  onClick: isImageFile
                    ? () =>
                        props.onPreview?.(URL.createObjectURL(fileWithId.file))
                    : undefined,
                  style: isImageFile
                    ? { cursor: "pointer", userSelect: "none" }
                    : undefined,
                }}
                header={
                  <Text
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: "150px",
                      display: "inline-block",
                    }}
                    size={100}
                    weight="semibold"
                    title={fileWithId.file.name}
                  >
                    {fileWithId.file.name}
                  </Text>
                }
                action={
                  <Button
                    appearance="transparent"
                    icon={<Delete16Regular />}
                    style={{ color: designTokens.semantic.error }}
                    onClick={() => props.onRemove(fileWithId)}
                  />
                }
              />
            </Card>
          );
        })}
    </>
  );
};
